angular.module('psModule').factory('benefitService', function ($q, $resource, $rootScope, $translate, $location) {
    let bs = $location.search()['useBS'];
    let cache = $location.search()['ignoreCache'];
    let fbeskedResource = $resource('/ps/api/benefits/fbesked', {
        lang: $translate.use(),
        useBS: bs,
        ignoreCache: cache
    }, {});

    const benefitSummaryRequestWrapperResource = $resource('/ps/api/benefits/benefit-summary-request-wrapper', { salary: '@salary' }, {});

    let fbeskedFuture;
    let fbeskedPromise;

    /**
     * Internal helper that performs the actual data fetch from the backend.
     *
     * It creates a new promise for the `fbesked` data and immediately starts
     * fetching it. This promise is then cached and returned by `getFbesked()`.
     * This function is called once when the service is first loaded, and again
     * every time `clearFbeskedCache()` is used to force a refresh.
     */
    function initializeFbesked() {
        fbeskedFuture = $q.defer();
        fbeskedPromise = fbeskedFuture.promise;

        if ($rootScope.user.fullAccess) {
            fbeskedResource.get().$promise
                .then(function (data) {
                    fbeskedFuture.resolve(data);
                }, function (error) {
                    fbeskedFuture.reject(error);
                });
        }
    }

    initializeFbesked();

    let benefitService = {};

    benefitService.getFbesked = function () {
        return fbeskedPromise;
    };

    /**
     * Forces a refresh of the cached `fbesked` data.
     *
     * This is the public method that should be called from controllers after an
     * operation that makes the current data outdated (e.g., saving or deleting a self reported salary).
     */
    benefitService.clearFbeskedCache = function () {
        initializeFbesked();
    };

    benefitService.getBenefitSummaryRequestWrapper = function (salary) {
        return benefitSummaryRequestWrapperResource.get({salary: salary}).$promise;
    };

    benefitService.getSubCategory = function (category, subcat) {
        return fbeskedPromise.then(function (fbesked) {
            return fbesked.categoryMap[category].subCategoryMap[subcat];
        });
    };

    benefitService.calculateTotalCompensation = function (ersattningar) {
        return _.reduce(ersattningar, function (memo, fbelopp) {
            if (!angular.isDefined(fbelopp.ersattning.belopp) || !angular.isDefined(fbelopp.ersattning.belopp.value) || !fbelopp.ersattning.includeInSum) {
                return memo;
            }
            return memo + fbelopp.ersattning.belopp.value;
        }, 0);
    };

    var visibilityHides = ['NONE', 'HEADER_ONLY'];
    var visibilityValueHides =  visibilityHides.concat(['HEADER_AND_LONGTEXT']);

    benefitService.hideErsattningar = function(ersattning) {
        return $rootScope.checkDefined(ersattning, 'visibility.PrivateServices') &&
            ersattning.visibility.PrivateServices === visibilityHides[0];
    };

    benefitService.hideDesc = function(ers) {
        return $rootScope.checkDefined(ers, 'visibility.PrivateServices') &&
            _.contains(visibilityHides, ers.visibility.PrivateServices);
    };

    benefitService.hideValue = function(ers) {
        return $rootScope.checkDefined(ers, 'visibility.PrivateServices') &&
            _.contains(visibilityValueHides, ers.visibility.PrivateServices);
    };

    return benefitService;

});
